import CustomTransfer from './CustomTransfer'
import CityCascader from './CityCascader'
import FormTable from './FormTable'
import FormTableItem from './FormTable/form-table-item.vue'
import Selectorg from './Selectorg'
import CategoryCas from './CategorySelect'
export default {
    install(Vue)  {
        Vue.component(CustomTransfer.name, CustomTransfer)
        Vue.component(CityCascader.name, CityCascader)
        Vue.component(FormTable.name, FormTable)
        Vue.component(FormTableItem.name, FormTableItem)
        Vue.component(Selectorg.name, Selectorg)
        Vue.component(CategoryCas.name, CategoryCas)
    }
}



// WEBPACK FOOTER //
// ./src/components/index.js